//----- Component --------------------------------------------------------/
// Developer     : Magali Perea
// Creation Date : 28/06/2023
// Version       : 1
// Description   : Tabs para mostrar datos del tanque
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState } from "react";
import Box from "@mui/material/Box";
import { DialogTitle, Typography } from "@mui/material";
import FichaTanque from "./FichaTanque";
import HistorialTanque from "./HistorialTanque";

// ICONOS
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";

//TABLAS
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function DatosTanques(props) {
  const [opcion, setOpcion] = useState("fichatecnica");
  const handleChange = (event, newValue) => {
    setOpcion(newValue);
  };

  const handleClose = props.handleCloseDialogFicha;

  return (
    <>
      <DialogTitle
        sx={{
          backgroundColor: "#1976D2",
          color: "white",
          position: "relative",
          textAlign: "center",
          px: 4,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            left: 8,
            top: "50%",
            transform: "translateY(-50%)",
            color: "white",
          }}
          aria-label="volver"
        >
          <ArrowBackIcon />
        </IconButton>

        <Typography variant="h6" component="div" sx={{ color: "white" }}>
          {`Datos Tanque (N° Serie: ${props.datos.nro_serie})`}
        </Typography>
      </DialogTitle>

      <Tabs
        value={opcion}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        variant="fullWidth"
      >
        <Tab value="fichatecnica" label="Ficha Técnica" />
        <Tab value="historial" label="Historial" />
      </Tabs>

      {opcion === "fichatecnica" ? <FichaTanque datos={props.datos} /> : null}
      {opcion === "historial" ? (
        <Box sx={{ maxHeight: "60vh", overflowY: "auto", px: 2 }}>
          <HistorialTanque datos={props.datos} />
        </Box>
      ) : null}
    </>
  );
}

export default DatosTanques;
